<template>
  <div
    :class="`md-layout-item md-size-${size} md-small-size-${
      size * 2
    } md-xsmall-size-100`"
  >
    <label>{{ label }}</label>
    <p>
      {{ value }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'Field',

  props: {
    label: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 25
    },
    value: {
      required: true
    }
  },

  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Quotations/FField.vue